import { createRouter as _createRouter, createWebHashHistory } from 'vue-router';
import routes from '@/router/routes';

// eslint-disable-next-line
export function createRouter() {
  return _createRouter({
    history: createWebHashHistory(),
    routes,
  });
}
